import {onFind} from "@elements/init-modules-in-scope";
import {on, findIn} from "@elements/dom-utils";
import * as formValidation from "@elements/form-validation";
import {clearAll, showNotification} from '@elements/alert-notification';


const selectors = {
    base: '.js-ajax-file-upload',
    form: '.js-ajax-file-upload__form',
    input: '.js-ajax-file-upload__input',
    btn: '.js-ajax-file-upload__btn',
    result: '.js-ajax-file-upload__result',
    loading: '.js-ajax-file-upload__loading',
    error: '.js-ajax-file-upload__error'
};

export function init() {
    onFind(selectors.base, (base) => {
        let form = findIn(selectors.form, base);
        let btn = findIn(selectors.btn, base);
        let loading = findIn(selectors.loading, base);

        on("click", (event) => {
            event.preventDefault();
            let formInstance;

            formValidation.getApi(form).then((formApi) => {
                formInstance = formApi.getFormInstance();

                formInstance.on('core.form.valid', () => {
                    loading.removeAttribute('hidden');

                    let result = findIn(selectors.result, base);
                    let errorMessage = findIn(selectors.error, base);

                    let fileInput = findIn(selectors.input, form);
                    let file = fileInput.files[0]

                    let formData = new FormData();
                    formData.append('file', file)

                    let url = form.getAttribute('data-action');

                    if (pendingRequest) {
                        pendingRequest.abort();
                        pendingRequest = null;
                    }

                    let pendingRequest = fetch( url, {
                        method: "POST",
                        body: formData,
                    });

                    showNotification({closable: true});
                    showNotification(pendingRequest);

                    //close notification after 3 seconds => customer request workfront ticket: 1863705
                    setTimeout(() => {
                        clearAll();
                    }, 3000);

                    pendingRequest.then((res) => {
                        return res.clone().json()
                    }).then((res) => {
                        if (res.success) {
                            result.innerHTML = res.html;
                        }else{
                            errorMessage.removeAttribute('hidden');
                            errorMessage.innerHTML = res.message;
                        }

                        loading.setAttribute('hidden', true);

                    }).catch((error) => {
                        if (error.name !== 'AbortError') {
                            console.error(error);

                            errorMessage.removeAttribute('hidden');

                            loading.setAttribute('hidden', true);
                        }
                    });
                });
            });
        }, btn);
    });
}
